'use strict';

const moment = require('moment');

const getCategoryFromBirthday = (categories, fromDate = null) => {

  const getCategory = (birthday, dateRelative = moment()) => {
    const age = moment(dateRelative)
      .endOf(fromDate)
      .diff(birthday, 'years');

    const category = categories.find(category => {
      const {
        boundary: {
          min,
          max,
        },
      } = category;

      return age >= min && age <= max;
    }) || {};

    const { name } = category;

    return name;
  };

  return getCategory;
};

module.exports = getCategoryFromBirthday;
